import React, { useState } from "react";
import { skillsData } from "../../data/portfolioData";
import SectionHeading from "../public/SectionHeading";

const DEVICON_MAP = {
  "spring boot rest api": "spring",
  "spring boot": "springboot",
  "spring framework": "spring",
  spring: "spring",
  nodejs: "nodejs",
  "node.js": "nodejs",
  node: "nodejs",
  nestjs: "nestjs",
  "nest.js": "nestjs",
  "react.js": "react",
  react: "react",
  "next.js": "nextjs",
  nextjs: "nextjs",
  "core java": "java",
  java: "java",
  "git & github": "git",
  git: "git",
  github: "github",
  docker: "docker",
  "google cloud": "googlecloud",
  gcp: "googlecloud",
  javascript: "javascript",
  typescript: "typescript",
  "tailwind css": "tailwindcss",
  tailwind: "tailwindcss",
  mongodb: "mongodb",
  mysql: "mysql",
  postgresql: "postgresql",
  "postgres sql": "postgresql",
  redis: "redis",
  firebase: "firebase",
  hibernate: "hibernate",
  maven: "maven",
  gradle: "gradle",
  "vs code": "vscode",
  vscode: "vscode",
  postman: "postman",
  figma: "figma",
  linux: "linux",
  bash: "bash",
  kubernetes: "kubernetes",
};

const SIMPLE_MAP = {
  "rest apis": "openapiinitiative",
  "rest api": "openapiinitiative",
  "spring boot rest api": "springboot",
  "google cloud": "googlecloud",
  "git & github": "git",
  ci: "githubactions",
  "ci/cd": "githubactions",
};

const normalize = (skill) => skill.toLowerCase().trim();

const deviconSlugFor = (skill) => {
  const key = normalize(skill);
  if (DEVICON_MAP[key]) return DEVICON_MAP[key];
  return key
    .replace(/&/g, "")
    .replace(/\s+/g, "")
    .replace(/\./g, "")
    .replace(/-/g, "");
};

const simpleSlugFor = (skill) => {
  const key = normalize(skill);
  if (SIMPLE_MAP[key]) return SIMPLE_MAP[key];
  return key
    .replace(/\s+/g, "")
    .replace(/\./g, "")
    .replace(/-/g, "")
    .replace(/&/g, "");
};

const iconSources = (skill) => {
  const dev = deviconSlugFor(skill);
  const simple = simpleSlugFor(skill);
  return [
    `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${dev}/${dev}-original.svg`,
    `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${dev}/${dev}-plain.svg`,
    `https://cdn.simpleicons.org/${simple}`,
  ];
};

const SkillTile = ({ skill }) => {
  const [sourceIndex, setSourceIndex] = useState(0);
  const sources = iconSources(skill);
  const src = sources[sourceIndex];

  return (
    <div className="skill-tile">
      <span className="skill-tile-icon">
        {src ? (
          <img
            src={src}
            alt={`${skill} logo`}
            loading="lazy"
            decoding="async"
            onError={() => setSourceIndex((current) => current + 1)}
          />
        ) : (
          <span className="skill-tile-fallback" aria-hidden="true">
            {skill.charAt(0).toUpperCase()}
          </span>
        )}
      </span>
      <span className="skill-tile-label">{skill}</span>
    </div>
  );
};

const Skills = () => {
  const totalSkills = skillsData.reduce(
    (total, category) => total + category.skills.length,
    0,
  );

  return (
    <section className="public-section public-section--white" id="skills">
      <div className="container">
        <SectionHeading
          eyebrow="Toolkit"
          title="Skills"
          description="The languages, frameworks, and tools I reach for when turning an idea into a working system."
          aside={<span className="section-count">{totalSkills} tools</span>}
        />

        <div className="row skills-grid">
          {skillsData.map((category) => {
            return (
              <div className="col s12 m6" key={category.category}>
                <article className="skill-category">
                  <div className="skill-category-head">
                    <h3 className="skill-category-title">
                      {category.category}
                    </h3>
                    <span className="skill-category-count">
                      {category.skills.length} skills
                    </span>
                  </div>

                  <div className="skills-tiles">
                    {category.skills.map((skill) => (
                      <SkillTile skill={skill} key={skill} />
                    ))}
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
